import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { applyJob, withdrawJob } from '../../Redux/Actions/jobBoard'
import { useNavigate } from 'react-router-dom'
import share from "../../Assets/svg/share.svg"
import fb from "../../Assets/svg/fb.svg"
import whatsapp from "../../Assets/svg/whatsapp.svg"
import copyLink from "../../Assets/svg/copy_link.svg"

const JobCard = ({ nologo, screening, withdrawApplication, item, onCardClick }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const kids = useSelector(state => state.dashboard.kids);
    const resumeData = useSelector(s => s.ProfileSteps.submissionData);
    const data = useSelector(s => s.ProfileSteps.introData);
    const profileData = useSelector(s => s.ProfileSteps.profileData);
const [copySuccess, setCopySuccess] = useState(false);  
  
  const [applicationStatus, setApplicationStatus] = useState(item?.application_status);
  const isProfileComplete = 
    resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl &&
    data?.length > 0 &&
    profileData?.user_name;
   
  const handleApply = (e) => {
    e.stopPropagation();
    setApplicationStatus("APPLICATION_SENT");
    dispatch(applyJob({ job_id: item?.job_id, kid_id: kids[0]?.id }))
  }
  
  const handleApplyClick = (e) => {
    e.stopPropagation();
    if (isProfileComplete) {
      handleApply(e);
    }
  }
  
  const handleWithdraw = (e) => {
    e.stopPropagation();
    setApplicationStatus("WITHDRAWN");
    dispatch(withdrawJob({ job_id: item?.job_id, kid_id: kids[0]?.id }))
  }


  const handleModalOpen = (e) => {
    e.stopPropagation();
  }


  const handleCardClick = () => {
    if (onCardClick) {
      onCardClick();
    }
  }
  
  const modalId = `withdrawModal_${item?.job_id}`;
  const applymodalId = `applyModal_${item?.job_id}`;
   const getShareUrl = () => {
    return `${window.location.origin}/job-detail?id=${item?.job_unique_id}`;
  };
    const handleCopyLink = async () => {
    try {
      const fullUrl = getShareUrl();
      await navigator.clipboard.writeText(fullUrl);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };
  const handleWhatsAppShare = () => {
    const url = getShareUrl();
    const text = encodeURIComponent(`View the job details and apply directly here: ${url}`);
    
    if (/Android|iPhone/i.test(navigator.userAgent)) {
      window.open(`whatsapp://send?text=${text}`, '_blank');
    } else {
      window.open(`https://wa.me/?text=${text}`, '_blank');
    }
  };

  const handleFacebookShare = () => {
    const url = getShareUrl();
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
  };
  return (
    <>
      <div className={`job-card ${nologo}`} onClick={handleCardClick}>
        <div className='position-relative'>
          <div className="job-card-header">
            <img src={item?.company_logo_url} alt="" />
            <h2>{item?.company_name}</h2>
          </div>
        <div className="dropdown share-dropdown position-absolute end-0 top-0" onClick={(e) => {e.stopPropagation()}}>
          <button 
            type='button' 
            className="default-btn no-after bg-transparent border-0 dropdown-toggle" 
            id="dropdownMenuButton123" 
            data-bs-toggle="dropdown" 
            aria-expanded="false"
          >
            <img src={share} alt="Share icon" />
            Share
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton123">
            <li className="dropdown-item">
              <span onClick={handleCopyLink} style={{ cursor: 'pointer' }}>
                <img src={copyLink} alt="Copy link icon" />
                {copySuccess ? 'Copied!' : 'Copy Link'}
              </span>
            </li> 
            <li className="dropdown-item">
              <span onClick={handleWhatsAppShare} style={{ cursor: 'pointer' }}>
                <img src={whatsapp} alt="WhatsApp icon" />
                WhatsApp
              </span>
            </li> 
            {/* <li className="dropdown-item">
              <span onClick={handleFacebookShare} style={{ cursor: 'pointer' }}>
                <img src={fb} alt="Facebook icon" />
                Facebook
              </span>
            </li>  */}
          </ul>
        </div>
        </div>
        <div className="job-card-body pt-4">
          <ul className='job-card-feature-list'>
            {item?.job_title && <li className='fw-bold'>
              <img src="./svg/sdm.svg" alt="" />
              {item?.job_title}
            </li>}
            {item?.job_department && <li>
              <img src="./svg/soe.svg" alt="" />
              {item?.job_department}
            </li>}
            {item?.job_location && <li>
              <img src="./svg/location.svg" alt="" />
              {item?.job_location}
            </li>}
          </ul>
          <div className={`screening-sec ${screening}`} onClick={(e) => e.stopPropagation()}>
            <h2>This job requires Proof of Skill</h2>
            <button type='button' className='default-btn blue-border-btn position-static'>
              Add Screening Criteria
            </button>
          </div>
          <div className='card-tags-main'>
            {item?.application_last_date && <div className="card-tags">
              Apply by : {new Date(item?.application_last_date).toLocaleDateString('en-GB', { 
                day: 'numeric', 
                month: 'short', 
                year: 'numeric' 
              })}
            </div>}
            {item?.ctc && <div className="card-tags">
              <span className='fw-semibold'>{`${item?.job_type == "FULLTIME" ? "CTC" : "Stipend"}`} : </span> ₹{(item?.ctc || 0).toLocaleString('en-IN')}
            </div>}
          </div>
          {item?.application_status === "APPLICATION_SENT" ? (
            <button 
              className='default-btn blue-border-btn' 
              data-bs-toggle="modal" 
              data-bs-target={`#${modalId}`}
              onClick={handleModalOpen}
            >
              Withdraw Application
            </button>
          ) : (
            <button 
              className={`default-btn ${screening}`}
              {...(!isProfileComplete && {
                'data-bs-toggle': 'modal',
                'data-bs-target': `#${applymodalId}`
              })}
              onClick={handleApplyClick}
            >
              Apply Now
            </button>
          )}
        </div>
        
        {/* Withdraw Modal */}
        <div 
          className="modal fade common-modal" 
          id={modalId}
          data-bs-backdrop="static" 
          data-bs-keyboard="false" 
          tabIndex="-1" 
          aria-labelledby={`${modalId}Label`}
          aria-hidden="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content border-0">
              <div className="modal-body text-center px-3 px-lg-5">
                <button 
                  type="button" 
                  className="btn-close" 
                  data-bs-dismiss="modal" 
                  aria-label="Close"
                ></button>
                <h2 className='popup-title mb-3'>Withdraw Application</h2>
                <p className='mb-4'>
                  Are you sure you want to withdraw your application for {item?.job_title} at {item?.company_name}?
                </p>
                <button 
                  type="button" 
                  onClick={handleWithdraw} 
                  data-bs-dismiss="modal" 
                  className="default-btn w-100 mb-3"
                >
                  Yes, Withdraw
                </button>
                <button 
                  type="button" 
                  className="default-btn blue-border-btn w-100" 
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Apply Modal */}
        <div 
          className="modal fade common-modal" 
          id={applymodalId}
          data-bs-backdrop="static" 
          data-bs-keyboard="false" 
          tabIndex="-1" 
          aria-labelledby={`${applymodalId}Label`}
          aria-hidden="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content border-0">
              <div className="modal-body text-center px-3 px-lg-5">
                <button 
                  type="button" 
                  className="btn-close" 
                  data-bs-dismiss="modal" 
                  aria-label="Close"
                ></button>
                <h2 className='popup-title mb-3'>Update your Profile</h2>
                <p className='mb-4'>
                  Upload your <strong>resume</strong> and add a 1-2 minute <strong>introduction video</strong> to unlock job applications and increase your chances of selection.
                </p>
                <button 
                  type="button" 
                  onClick={() => navigate("/profile")} 
                  data-bs-dismiss="modal" 
                  className="default-btn w-100 mb-3"
                >
                  Update Profile
                </button>
                <button 
                  type="button" 
                  className="default-btn blue-border-btn w-100" 
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default JobCard
